<template>
  <div class="pastVideo_item">
    <div class="pastVideo_item_img" @click="videoDetail">
      <img :src="item.thumbnailUrl" alt="">
      <img class="pastVideo_icon" src="../../static/image/interview/icon_2.png" alt="">
    </div>
    <div class="pastVideo_item_content">
      <div class="pastVideo_item_content_title">
        {{ item.title }}
      </div>
      <div class="pastVideo_item_content_time">
        <div>{{ item.publishTime.split(' ')[0] }}</div>
        <div>{{ item.totalBrowse }}{{ $t('videoViewNumber') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LectureTour",
  props:{
    item:{
      default:()=>{}
    }
  },
  methods:{
    videoDetail(){
      this.$router.push({
        path:this.$store.state.locale=='zh_CN'?'/videoDetail':'/en/videoDetail',
        query:{
          id:this.item.id,
          type:this.item.type.code,
          title:this.item.title
        }
      })

    }
  }
}
</script>

<style scoped lang="scss">
.pastVideo_item{
  width: 393px;
  height: 304px;
  background: #FFFFFF;
  border: 1px solid #EEEEEE;
  box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  overflow: hidden;
  .pastVideo_item_img{
    position: relative;
    width: 393px;
    height: 217px;
    cursor: pointer;
    img{
      width: 100%;
      height: 100%;
    }
    .pastVideo_icon{
      width: 40px;
      height: 40px;
      position: absolute;
      bottom: 24px;
      right: 10px;
    }
  }

  .pastVideo_item_content{
    padding: 10px;
    .pastVideo_item_content_title{
      text-align: left;
      color: #333333;
      font-size: 16px;
      font-weight: bold;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
      margin-bottom: 20px;
    }
    .pastVideo_item_content_time{
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      color: #999999;
      font-size: 14px;
    }
  }
}
</style>